import React from 'react';
import { Link } from 'react-router-dom';

const FooterLink = ({ to, children }) => (
  <Link to={to} className="text-slate-400 hover:text-[#00BFA6] transition-colors text-sm">
    {children}
  </Link>
);

export const Footer = () => {
  return (
    <footer className="py-12 px-4 bg-slate-900">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          {/* Logo & Description */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_aa9a9291-9586-4ce8-b3a3-ae4b4447418a/artifacts/4cz14yba_Move_Logo_Trans.png" 
              alt="Mercapoli Move"
              className="h-8 mb-4"
            />
            <p className="text-slate-400 text-sm">
              La super-app de movilidad y logística del ecosistema Mercapoli.
            </p>
          </div>

          {/* Servicios */}
          <div>
            <h4 className="font-bold text-white mb-4">Servicios</h4>
            <ul className="space-y-2">
              <li><FooterLink to="/services/ride-hailing">Ride-Hailing</FooterLink></li>
              <li><FooterLink to="/services/vehicle-rentals">Renta de Vehículos</FooterLink></li>
              <li><FooterLink to="/services/logistics">Fletes y Mandados</FooterLink></li>
              <li><FooterLink to="/services/digi-wallet">Digi Wallet</FooterLink></li>
            </ul>
          </div>

          {/* Empresa */}
          <div>
            <h4 className="font-bold text-white mb-4">Empresa</h4>
            <ul className="space-y-2">
              <li><FooterLink to="/company/about">Sobre Nosotros</FooterLink></li>
              <li><FooterLink to="/company/drivers">Conductores</FooterLink></li>
              <li><FooterLink to="/company/vehicle-owners">Dueños de Vehículos</FooterLink></li>
              <li><FooterLink to="/company/support">Soporte</FooterLink></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-bold text-white mb-4">Legal</h4>
            <ul className="space-y-2">
              <li><FooterLink to="/legal/terms">Términos de Servicio</FooterLink></li>
              <li><FooterLink to="/legal/privacy">Política de Privacidad</FooterLink></li>
              <li><FooterLink to="/legal/cookies">Cookies</FooterLink></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row items-center justify-between pt-8 border-t border-slate-800">
          <p className="text-slate-500 text-sm">
            © 2025 Mercapoli Move. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-4 mt-4 md:mt-0">
            <span className="text-slate-500 text-sm">Disponible en:</span>
            <span className="text-slate-400 text-sm">🇬🇹 GT</span>
            <span className="text-slate-400 text-sm">🇲🇽 MX</span>
            <span className="text-slate-400 text-sm">🇨🇴 CO</span>
            <span className="text-slate-400 text-sm">🇵🇪 PE</span>
            <span className="text-slate-400 text-sm">🇺🇸 US</span>
            <span className="text-slate-400 text-sm">🇧🇷 BR</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
